import * as typedjsonobject from 'typedjson';
import { ensureTypeDescriptor, ArrayTypeDescriptor, MapTypeDescriptor, SetTypeDescriptor } from "typedjson/lib/esm5/type-descriptor";
import { isSubtypeOf, isInstanceOf, isValueDefined, nameof } from "typedjson/lib/esm5/helpers";
import { mergeOptions } from "typedjson/lib/esm5/options-base";
export const TypedJSON = Object.assign(Object.assign({}, typedjsonobject), {
  utils: {
    isInstanceOf,
    isValueDefined,
    nameof,
    isSubtypeOf
  },
  options: {
    mergeOptions
  },
  typeDescriptor: {
    ensureTypeDescriptor,
    ArrayTypeDescriptor,
    MapTypeDescriptor,
    SetTypeDescriptor
  }
});